/* eslint-disable @typescript-eslint/no-explicit-any */
import {fabric} from 'fabric';
import {
  PartModel,
  PolygonObject,
  PropertiesTextModel,
} from '../models/interfaces/';
const { Rect, Line, Circle, Ellipse, Path, Polygon, Polyline, Triangle } =
  fabric;

const RL_FILL = '#FFF',
  RL_STROKE = '#000',
  RL_PREVIEW_WIDTH = 140,
  RL_PREVIEW_HEIGHT = 120,
  RL_CHAIR_STROKE = '#999',
  RL_CHAIR_FILL = '#FFF',
  RL_CHAIR_TUCK = 6,
  RL_VIEW_WIDTH = 120,
  RL_VIEW_HEIGHT = 40,
  RL_FOOT = 12,
  RL_AISLEGAP = 12 * 3,
  RL_ROOM_OUTER_SPACING = 48,
  RL_ROOM_INNER_SPACING = 4,
  RL_ROOM_STROKE = '#000',
  RL_CORNER_FILL = '#88f',
  RL_UNGROUPABLES = ['CHAIR', 'MISCELLANEOUS', 'DOOR'],
  RL_CREDIT_TEXT = 'Technoapes Software',
  RL_CREDIT_TEXT_PARAMS = {
    fontSize: 12,
    fontFamily: 'Arial',
    fill: '#999',
    left: 12,
  };
  

const createBasicShape = (
  part: PartModel,
  stroke = '#AAAAAA',
  fill = 'white'
) => {
  part.definition.stroke = stroke;
  part.definition.fill = fill;
  let fObj;
  switch (part.type) {
    case PolygonObject.CIRCLE:
      fObj = new Circle(part.definition);
      break;
    case PolygonObject.ELLIPSE:
      fObj = new Ellipse(part.definition);
      break;
    case PolygonObject.LINE:
      fObj = new Line(part.line, part.definition);
      break;
    case PolygonObject.PATH:
      fObj = new Path(part.path as string, part.definition);
      break;
    case PolygonObject.POLYGON:
      fObj = new Polygon(part.definitionPoly!);
      break;
    case PolygonObject.POLYLINE:
      fObj = new Polyline(part.definitionPoly!);
      break;
    case PolygonObject.RECT:
      fObj = new Rect(part.definition);
      break;
    case PolygonObject.TRIANGLE:
      fObj = new Triangle(part.definition);
      break;
    case PolygonObject.TEXT:
      fObj = createText(part.definition);
      break;
    default:
      break;
  }

  return fObj;
};

const createText = (properties: PropertiesTextModel) => {
  let { text } = properties;
  if (!text) {
    text = '';
  }
  if (properties.direction === 'VERTICAL') {
    const chars = [];
    for (const char of text) {
      chars.push(char);
    }
    text = chars.join('\n');
  }

  return new fabric.IText(text, {
    fontSize: properties.font_size,
    lineHeight: 0.8,
    name: properties.name,
    hasControls: false,
    top: properties ? (properties.top ? properties.top : 0) : 0,
    left: properties ? (properties.left ? properties.left : 0) : 0,
  });
};

const createFurniture = (type: string, object: any, complement = null) => {
  if (type === 'TABLE') {
    //   return createTable(object, chair);
  } else if (type === 'TEXT') {
    return createText(object);
  } else if (type === 'LAYOUT') {
    return object;
  } else {
    return createShape(
      object,
      RL_STROKE,
      object.backgroundColor ? object.backgroundColor : RL_FILL,
      type
    );
  }
};

const createShape = (
  object: any,
  stroke = RL_CHAIR_STROKE,
  fill = RL_CHAIR_FILL,
  type = 'FURNITURE'
): fabric.Group => {
  const parts = object.parts.map((obj: any) =>
    createBasicShape(obj, stroke, fill)
  );
  const elName = object.elementName ? `:${object.elementName}` : '';
  const group = new fabric.Group(
    parts,
    object.top !== undefined
      ? {
         name: `${type}:${object.title}${elName}`,
          hasControls: false,
          top: object.top,
          left: object.left,
          selectable: true,
          evented: true,
          type: 'group',
          visible: true,
          angle: object?.angle ? object.angle : 0,
        }
      : {
          name: `${type}:${object.title}${elName}`,
          hasControls: false,
          originX: 'center',
          originY: 'center',
          selectable: true,
          evented: true,
          type: 'group',
          visible: true,
          angle: object?.angle ? object.angle : 0,
        }
  );

  group.on('selection:created', function (options: any) {
    console.log('seleccionado');
    console.log(options);
  });
  group.moveCursor = 'move';
  group.hoverCursor = 'move';
  return group;
};

const Left = (wall: any) => (wall.x1 < wall.x2 ? wall.x1 : wall.x2);
const Top = (wall: any) => (wall.y1 < wall.y2 ? wall.y1 : wall.y2);
const Right = (wall: any) => (wall.x1 > wall.x2 ? wall.x1 : wall.x2);
const Bottom = (wall: any) => (wall.y1 > wall.y2 ? wall.y1 : wall.y2);

const OFFSET = RL_ROOM_INNER_SPACING / 2;

export {
  Bottom,
  createBasicShape,
  createFurniture,
  createText,
  Left,
  OFFSET,
  Right,
  RL_AISLEGAP,
  RL_CHAIR_FILL,
  RL_CHAIR_STROKE,
  RL_CHAIR_TUCK,
  RL_CORNER_FILL,
  RL_CREDIT_TEXT,
  RL_CREDIT_TEXT_PARAMS,
  RL_FILL,
  RL_FOOT,
  RL_PREVIEW_HEIGHT,
  RL_PREVIEW_WIDTH,
  RL_ROOM_INNER_SPACING,
  RL_ROOM_OUTER_SPACING,
  RL_ROOM_STROKE,
  RL_STROKE,
  RL_UNGROUPABLES,
  RL_VIEW_HEIGHT,
  RL_VIEW_WIDTH,
  Top,
};
